import Vue from 'vue'

import { createRecord, fetchUserProfile } from '@/utils/api'
import { profileUrl } from '@/utils/helpers'
import { AUTH_LOGOUT, AUTH_PERMISSIONS } from '@/store/actions/auth'
import {
  USER_ERROR,
  USER_REGISTRATION,
  USER_REQUEST,
  USER_SUCCESS
} from '@/store/actions/user'

const state = { status: '', profile: {} }

const getters = {
  getProfile: state => state.profile,
  isProfileLoaded: state => !!state.profile.name
}

const actions = {
  [USER_REQUEST]: ({ commit, dispatch }) => {
    commit(USER_REQUEST)
    fetchUserProfile().then(response => {
      commit(USER_SUCCESS, response)
      commit(AUTH_PERMISSIONS, response.preferences)
    }).catch(() => {
      commit(USER_ERROR)
      dispatch(AUTH_LOGOUT)
    })
  },
  [USER_REGISTRATION]: ({ commit }, user) => {
    commit(USER_REQUEST)
    return new Promise((resolve, reject) => {
      createRecord('signup', user).then(response => {
        resolve(response)
      }).catch((error) => {
        commit(USER_ERROR)
        reject(error)
      })
    })
  }
}

const mutations = {
  [USER_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [USER_SUCCESS]: (state, response) => {
    state.status = 'success'
    response.picture = profileUrl(response)
    Vue.set(state, 'profile', response)
  },
  [USER_ERROR]: (state) => {
    state.status = 'error'
  },
  [AUTH_LOGOUT]: (state) => {
    state.profile = {}
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
